import { h, Component } from 'preact';
import find from 'dlv';
import style from './style';
import root from '@components/root';
import { parseImageUrl } from '@helpers';

const interactionObserverSupported = 'IntersectionObserver' in root;
const cache = {};
const SNAP_TO = 64;

let queue = [];
let running = false;

export function clampImageWidth(w) {
  // Snap image width to 64px increments

  if (!w) return w;
  const width = w;

  const remainder = width % SNAP_TO;

  if (remainder) {
    return width + (SNAP_TO - remainder);
  }
  return width;
}

function flushQueue() {
  running = true;
  const self = queue[0];
  window.requestAnimationFrame(() => {
    if (self && self.base) {
      const params = {
        dpr: window.devicePixelRatio || 1,
        q: 90,
        format: 'auto',
      };
      if (self.props.width || self.props.height) {
        if (self.props.height) {
          params.h = parseInt(self.props.height);
        }
        if (self.props.width) {
          params.w = parseInt(self.props.width);
        }
      } else {
        const dimensions = self.base.parentElement.getBoundingClientRect();
        const w =
          parseInt(dimensions.width) > 10 ? parseInt(dimensions.width) : void 0;
        const h =
          parseInt(dimensions.height) > 10
            ? parseInt(dimensions.height)
            : void 0;
        if (w > h) {
          params.w = w;
          params.h = w;
        } else if (h > w) {
          params.w = h;
          params.h = h;
        } else {
          params.w = w;
          params.h = h;
        }
      }

      if (params.w) {
        params.w = clampImageWidth(params.w);
      }
      if (params.h) {
        params.h = clampImageWidth(params.h);
      }

      self.setState({
        dimensions: `?${Object.keys(params)
          .filter(key => params[key])
          .map(key => `${key}=${params[key]}`)
          .join('&')}`,
      });
      if (find(self, 'props.src'))
        cache[find(self, 'props.src')] =
          (cache[find(self, 'props.src')] || 0) + 1;
    }

    queue = queue.filter((item, index) => index);

    if (queue[0]) {
      flushQueue();
    } else {
      running = false;
    }
  });
  return;
}
function revealImage(self) {
  queue.push(self);
  if (!running) {
    flushQueue();
  }
}

class Image extends Component {
  constructor() {
    super();
    if (cache[find(this, 'props.src')]) {
      revealImage(this);
    }
  }

  loadImage(src) {
    fetch(`${src}?w=2&h=2&q=0&auto=format&dpr=1`, { mode: 'no-cors' })
      .then(() => {
        this.setState({ ready: true }, () => {
          if (this.intersecting) {
            revealImage(this);
          }
        });
      })
      .catch(() => {
        this.setState({ ready: true }, () => {
          if (this.intersecting) {
            revealImage(this);
          }
        });
      });
  }
  getImage() {
    const self = this;
    if (interactionObserverSupported && self.base && self.base.nodeType === 1) {
      self.lazyImageObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          this.boundingClientRect = entry.boundingClientRect;
          if (entry.isIntersecting && self.lazyImageObserver) {
            revealImage(self);
            this.intersecting = true;
            // if(self.base) {
            // 	self.lazyImageObserver.unobserve(self.base);
            // 	self.lazyImageObserver = null;
            // } else {
            // 	self.lazyImageObserver.disconnect();
            // 	self.lazyImageObserver = null;
            // }
          } else {
            this.intersecting = false;
          }
        });
      });
      self.lazyImageObserver.observe(self.base);
    } else {
      revealImage(self);
    }
  }
  componentDidMount() {
    if (cache[find(this, 'props.src')]) {
      revealImage(this);
    }
    this.getImage(this.props.src);
  }
  componentWillUnmount() {
    if (this.lazyImageObserver) {
      if (this.base) {
        this.lazyImageObserver.unobserve(this.base);
        this.lazyImageObserver.disconnect();
      } else {
        this.lazyImageObserver.disconnect();
      }
      this.lazyImageObserver = null;
    }
  }
  componentWillReceiveProps({ src }) {
    if (this.props.src !== src && src) {
      if (cache[src]) {
        revealImage(this);
      } else {
        this.getImage(src);
      }
    }
  }
  render(props, state) {
    const url = props.src.startsWith('data:image')
      ? props.src
      : parseImageUrl(props.src);
    return state.err ? null : (
      <img
        height={props.height}
        width={props.width}
        alt={props.alt}
        cached={cache[props.src] > 1 ? true : null}
        class={`${style.image}${props.class ? ` ${props.class}` : ''}`}
        src={
          !state.dimensions
            ? null
            : `${url}${
                !props.src.startsWith('data:image')
                  ? state.dimensions.replace(
                      '?',
                      props.src.includes('?') ? '&' : '?'
                    )
                  : ''
              }`.replace('format=auto', 'auto=format')
        }
        style={`${props.style}`}
      />
    );
  }
}
export default Image;



// WEBPACK FOOTER //
// ./components/image/index.js